<template>
  <div
    v-if="$store.getters['app/legacyUrl'].length && $store.getters['app/beta']"
    class="beta-toggle-component-container"
  >
    <icon
      name="beta"
      variant="white"
    />
    Beta <a
      :href="legacyUrl"
      class="back"
    >Back to Original</a>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  computed: {
    legacyUrl() {
      const port = (process.env.NODE_ENV === 'development' && process.env.API_PORT) ? `:${process.env.API_PORT}` : '';
      return `https://${this.$store.getters['app/legacyUrl']}${port}`;
    },
  },
};
</script>

<style lang='scss' scoped>
  .beta-toggle-component-container {
    align-items: center;
    background: $somewhat-know;
    /*border: 1px solid rgba(0,0,0,.2);*/
    border-radius: rem-calc(4);
    box-sizing: border-box;
    color: $white-1;
    display: flex;
    font: {
      size: rem-calc(14);
      weight: $semi-bold;
    }
    height: rem-calc(28);
    margin-right: rem-calc(12);
    padding: rem-calc(6) rem-calc(8);
    text-transform: uppercase;

    @include breakpoint(small) {
      margin-right: rem-calc(32);
    }

    img {
      margin-right: rem-calc(4);
      width: rem-calc(16);
    }

    a {
      background: rgba(255,255,255,.76);
      border-radius: rem-calc(2);
      color: #DD8819;
      font-size: rem-calc(12);
      line-height: rem-calc(16);
      margin: 0 rem-calc(-6) 0 rem-calc(16);
      padding: rem-calc(4) rem-calc(8);
      text-transform: none;
      white-space: nowrap;

      @include breakpoint(small) {
        margin-left: auto;
      }

      &:visited {
        color: #DD8819;
      }

      &:hover {
        background: $white-1;
        color: hlt-darken(#DD8819, 10%);
      }
    }
  }
</style>
